import { Grid } from '@mui/material'
import { Root } from './prev-next.styled'
import { useIntl } from 'react-intl'
import ArrowheadLeftIcon from '../../../atoms/icons/arrowhead-left-icon'
import ArrowheadRightIcon from '../../../atoms/icons/arrowhead-right-icon'
import { cx } from '@emotion/css'
import Link from '../../../molecules/link'
import Typography from '../../../atoms/typography'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProducts } from '@bluheadless/ui-logic/src/hooks/product/useProducts'
import { useCatalogUrl } from '@bluheadless/ui-logic/src/hooks/useCatalogUrl'
import { useRouter } from 'next/router'
import { QUERY_PARAM_CATEGORY_ID } from '@bluheadless/ui-logic/src/constants'

const PrevNext = ({ className, ...props }) => {
	const { formatMessage } = useIntl()
	const router = useRouter()

	const {
		catalog: {
			products: { prevNext },
		},
	} = useConfig()

	const productContextValue = useProductContext()

	const [
		{
			product: { type, id, categoryIds },
		},
	] = productContextValue

	const productContextCategoryId = categoryIds.length == 1 ? categoryIds[0] : null
	const routerContextCategoryId = router?.query?.[QUERY_PARAM_CATEGORY_ID]

	const contextCategoryId = productContextCategoryId ?? routerContextCategoryId ?? null

	const { products } = useProducts({
		paused: !prevNext[type] || !contextCategoryId,
		where: {
			and: [
				{ visible: 1 },
				{
					categories: contextCategoryId ?? null,
				},
			],
		},
	})

	const currentProductIndex = products?.findIndex((product) => product.id === id) ?? -1

	const prevProductUrl = useCatalogUrl(
		products?.[currentProductIndex - 1]?.urlKey,
		{},
		{ [QUERY_PARAM_CATEGORY_ID]: contextCategoryId }
	)
	const nextProductUrl = useCatalogUrl(
		products?.[currentProductIndex + 1]?.urlKey,
		{},
		{ [QUERY_PARAM_CATEGORY_ID]: contextCategoryId }
	)

	return (
		prevNext[type] && (
			<Root
				className={cx('PrevNext-root', className)}
				container
				display="flex"
				justifyContent="space-between"
				{...props}
			>
				{prevProductUrl?.as && (
					<Grid item>
						<Link
							className={cx('prev-link')}
							underline="none"
							href={prevProductUrl}
							title={formatMessage({ id: 'prev_page_label' })}
						>
							<ArrowheadLeftIcon />
							<Typography variant="caption" color="grey.main">
								{formatMessage({ id: 'prev_page_label' })}
							</Typography>
						</Link>
					</Grid>
				)}
				{nextProductUrl?.as && (
					<Grid item>
						<Link
							className={cx('next-link')}
							underline="none"
							href={nextProductUrl}
							title={formatMessage({ id: 'next_page_label' })}
						>
							<Typography variant="caption" color="grey.main">
								{formatMessage({ id: 'next_page_label' })}
							</Typography>
							<ArrowheadRightIcon />
						</Link>
					</Grid>
				)}
			</Root>
		)
	)
}

export default PrevNext
